var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonePopupPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#3367CD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4523_30249)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 9.6,
    transform: "translate(7.2002 7.2002)",
    fill: "#3367CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8001 13.6801L9.40014 12.2801C9.24414 12.1241 8.99614 12.1241 8.84014 12.2801C8.68414 12.4361 8.68414 12.6841 8.84014 12.8401L10.5161 14.5161C10.6721 14.6721 10.9241 14.6721 11.0801 14.5161L15.3201 10.2801C15.4761 10.1241 15.4761 9.87615 15.3201 9.72015C15.1641 9.56415 14.9161 9.56415 14.7601 9.72015L10.8001 13.6801Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4523_30249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 9.6,
    fill: "white",
    transform: "translate(7.2002 7.2002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonePopupPrimary);
export default __webpack_public_path__ + "static/media/donePopupPrimary.2028d981.svg";
export { ForwardRef as ReactComponent };